import React from 'react';

import { cn } from 'shared/lib/utils';

function Label({
  className,
  disabled = false,
  ...props
}: React.ComponentProps<'label'> & {
  disabled?: boolean;
}) {
  return (
    <label
      data-slot="label"
      className={cn(
        'flex items-center gap-2 text-sm leading-normal font-medium tracking-wide text-body-copy-gray select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50',
        disabled && 'pointer-events-none text-gray-placeholder',
        className
      )}
      {...props}
    />
  );
}

export { Label };
